/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetExerciseCategorySchema } from '../models/GetExerciseCategorySchema';
import type { PatchExerciseCategorySchema } from '../models/PatchExerciseCategorySchema';
import type { PostExerciseCategorySchema } from '../models/PostExerciseCategorySchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExercisesCategoriesApi {
    /**
     * Api Delete
     * Delete exercises category.<br>Required permission: edit_exercises_categories
     * @returns void
     * @throws ApiError
     */
    public static exercisesCategoriesApiDeleteDelete({
        exerciseCategoryId,
    }: {
        exerciseCategoryId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/exercises-categories/{exercise_category_id}/',
            path: {
                'exercise_category_id': exerciseCategoryId,
            },
        });
    }
    /**
     * Api Get Detail
     * Get exercises categories.<br>Required permission: get_exercises_categories
     * @returns GetExerciseCategorySchema OK
     * @throws ApiError
     */
    public static exercisesCategoriesApiGetDetailGet({
        exerciseCategoryId,
    }: {
        exerciseCategoryId: string,
    }): CancelablePromise<GetExerciseCategorySchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/exercises-categories/{exercise_category_id}/',
            path: {
                'exercise_category_id': exerciseCategoryId,
            },
        });
    }
    /**
     * Api Patch
     * Patch exercises categories.<br>Required permission: edit_exercises_categories
     * @returns GetExerciseCategorySchema Created
     * @throws ApiError
     */
    public static exercisesCategoriesApiPatchPost({
        exerciseCategoryId,
        formData,
    }: {
        exerciseCategoryId: string,
        formData: {
            image?: (Blob | null);
            data: PatchExerciseCategorySchema;
        },
    }): CancelablePromise<GetExerciseCategorySchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/exercises-categories/{exercise_category_id}/',
            path: {
                'exercise_category_id': exerciseCategoryId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Api Get
     * Get exercises categories.<br>Required permission: get_my_company
     * @returns GetExerciseCategorySchema OK
     * @throws ApiError
     */
    public static exercisesCategoriesApiGetGet(): CancelablePromise<Array<GetExerciseCategorySchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/exercises-categories/',
        });
    }
    /**
     * Api Post
     * Create exercises categories.<br>Required permission: edit_exercises_categories
     * @returns GetExerciseCategorySchema Created
     * @throws ApiError
     */
    public static exercisesCategoriesApiPostPost({
        formData,
    }: {
        formData: {
            image?: (Blob | null);
            data: PostExerciseCategorySchema;
        },
    }): CancelablePromise<GetExerciseCategorySchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/exercises-categories/',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
}
